import {
  Component,
  Input,
  Output,
  EventEmitter, OnInit, OnChanges,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss']
})
export class ImagePreviewComponent {
  @Input() imageSrc: string;
  isVisible = false;

  constructor() {
  }

  show() {
    this.isVisible = true;
  }

  handleOk(): void {
    this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
  }

}
